import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'auto',
    height: '552px',
    width: '900px',
  },
  container: {
    width: '900px',
    display: 'flex',
    justifyContent: 'center',
  },
  root2: {
    width: '900px',
    [theme.breakpoints.only('md')]: {
      width: '43rem',
    },
    [theme.breakpoints.only('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.only('xs')]: {
      width: '100%',
    },
  },
  cardSelectImg: {
    height: '2rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    margin: '1.5rem',
    padding: '1.2rem',
  },
}))
